<template>
    <div class="row justify-center mt-4">
        <div
            style="
                border: 1px solid #dadce0;
                width: 688px;
                padding: 24px 24px 32px;
                border-radius: 4px;
            "
        >
            <div class="row justify-center font-20 font-medium mb-3">
                Thông tin khai báo vé
            </div>

            <div class="row justify-space-between mb-3">
                <DxCheckBox v-model="ThongTinKhaiBaoVe.InVe" text="In vé" />
                <div
                    class="text-link font-medium"
                    @click="MoTrang('/Bao-Cao/Ve-Doanh-Nghiep-Tu-Khai-Bao')"
                >
                    Danh sách vé tự khai báo
                </div>
            </div>
            <DxValidationGroup ref="formValidation">
                <div class="row mb-5">
                    <div class="xs6 mr-4">
                        <DxTextBox
                            label="Biển kiểm soát (*)"
                            v-model="ThongTinKhaiBaoVe.BienKiemSoat"
                            styling-mode="outlined"
                            validationMessageMode="always"
                            labelMode="floating"
                        >
                            <DxValidator>
                                <DxRequiredRule
                                    message="Không được bỏ trống!"
                                />
                                <DxStringLengthRule
                                    :max="20"
                                    message="Không được vượt quá 20 ký tự!"
                                />
                            </DxValidator>
                        </DxTextBox>
                    </div>
                    <div class="xs6">
                        <DxDateBox
                            label="Giờ xuất bến (*)"
                            labelMode="floating"
                            v-model="ThongTinKhaiBaoVe.GioXuatBen"
                            displayFormat="HH:mm:ss dd/MM/yyyy"
                            type="datetime"
                            dropDownButtonTemplate="customIcon"
                            validationMessageMode="always"
                            :useMaskBehavior="true"
                            stylingMode="outlined"
                        >
                            <DxValidator>
                                <DxRequiredRule
                                    message="Không được để trống!"
                                />
                                <DxRangeRule
                                    :max="MaxDate"
                                    :message="$i18n.t('DefaultString.MaxDate')"
                                />
                                <DxRangeRule
                                    :min="MinDate"
                                    :message="$i18n.t('DefaultString.MinDate')"
                                />
                            </DxValidator>
                            <template #customIcon="{}">
                                <DxButton icon="mdi mdi-calendar" />
                            </template>
                        </DxDateBox>
                    </div>
                </div>
                <div class="row mb-5">
                    <div class="xs6 mr-4">
                        <DxTextBox
                            label="Bến đến (*)"
                            v-model="ThongTinKhaiBaoVe.BenDen"
                            styling-mode="outlined"
                            validationMessageMode="always"
                            labelMode="floating"
                        >
                            <DxValidator>
                                <DxRequiredRule
                                    message="Không được bỏ trống!"
                                />
                                <DxStringLengthRule
                                    :max="128"
                                    message="Không được vượt quá 128 ký tự!"
                                />
                            </DxValidator>
                        </DxTextBox>
                    </div>
                    <div class="xs6">
                        <DxTextBox
                            label="Mã tuyến"
                            v-model="ThongTinKhaiBaoVe.MaTuyen"
                            styling-mode="outlined"
                            validationMessageMode="always"
                            labelMode="floating"
                        >
                            <DxValidator>
                                <!-- <DxRequiredRule message="Không được bỏ trống!" /> -->
                                <DxStringLengthRule
                                    :max="20"
                                    message="Không được vượt quá 20 ký tự!"
                                />
                            </DxValidator>
                        </DxTextBox>
                    </div>
                </div>
                <div class="row">
                    <div class="xs12">
                        <DxNumberBox
                            label="Số lượng vé (*)"
                            v-model="ThongTinKhaiBaoVe.SoLuongVe"
                            styling-mode="outlined"
                            validationMessageMode="always"
                            labelMode="floating"
                            :showSpinButtons="true"
                        >
                            <DxValidator>
                                <DxRequiredRule
                                    message="Không được bỏ trống!"
                                />
                                <DxRangeRule
                                    :min="1"
                                    message="Không được nhỏ hơn 1!"
                                />
                                <DxRangeRule
                                    :max="10"
                                    message="Không được vượt quá 10!"
                                />
                            </DxValidator>
                        </DxNumberBox>
                    </div>
                </div>
            </DxValidationGroup>
        </div>
    </div>
</template>
<script>
import {
    DxCheckBox,
    DxTextBox,
    DxNumberBox,
    DxValidator,
    DxDateBox,
    DxButton,
    DxValidationGroup,
} from "devextreme-vue";
import {
    DxRangeRule,
    DxRequiredRule,
    DxStringLengthRule,
} from "devextreme-vue/data-grid";

export default {
    components: {
        DxCheckBox,
        DxValidationGroup,
        DxDateBox,
        DxButton,
        DxTextBox,
        DxNumberBox,
        DxValidator,
        DxRangeRule,
        DxRequiredRule,
        DxStringLengthRule,
    },
    props: {},
    data() {
        return {
            MaxDate: this.$Helper.Common.getEndDay(
                new Date(this.$i18n.t("DefaultNumBer.MaxDate"))
            ),
            MinDate: this.$Helper.Common.getStartDay(
                new Date(this.$i18n.t("DefaultNumBer.MinDate"))
            ),
        };
    },
    computed: {
        ThongTinKhaiBaoVe: {
            get() {
                return this.$store.state.KhaiBaoVe.ThongTinKhaiBaoVe;
            },
            set(data) {
                this.$store.commit("KhaiBaoVe/Set", {
                    key: "ThongTinKhaiBaoVe",
                    data,
                });
            },
        },
    },
    methods: {
        MoTrang(link) {
            let routeData = this.$router.resolve({
                path: link,
            });
            window.open(routeData.href, "_blank");
        },
    },
    created() {},
    mounted() {},
};
</script>
<style scoped></style>
